import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = ''
}) => {
    const baseStyles = "font-['Montserrat'] font-semibold transition-all duration-300 flex items-center justify-center uppercase tracking-wider";

    const variants = {
        primary: 'bg-[#FF6B35] text-white hover:bg-[#E85D26] active:bg-[#D04E1A] disabled:bg-[#525252] disabled:cursor-not-allowed',
        secondary: 'bg-transparent text-[#FF6B35] border-2 border-[#FF6B35] hover:bg-[#FF6B35] hover:text-white active:bg-[#E85D26]',
        ghost: 'bg-transparent text-white hover:text-[#FF6B35] border border-[#2A2A2A] hover:border-[#FF6B35]',
    };

    const sizes = {
        sm: 'px-4 py-2 text-xs',
        md: 'px-6 py-3 text-sm',
        lg: 'px-8 py-4 text-base',
    };

    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyles} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${widthClass} ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;
